import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-slate-50" }
const _hoisted_2 = { class: "mt-2 mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5" }
const _hoisted_3 = { class: "flex items-start justify-between" }
const _hoisted_4 = { class: "text-xs font-bold text-slate-400" }
const _hoisted_5 = { class: "mt-2 text-3xl font-black text-slate-900" }
const _hoisted_6 = { class: "relative mt-4" }
const _hoisted_7 = {
  key: 0,
  class: "absolute bottom-full left-0 z-20 mb-3 w-52 rounded-xl bg-white border border-[#8c8c94] p-3.5 shadow-xl animate-in fade-in zoom-in-95 duration-200"
}
const _hoisted_8 = { class: "space-y-2.5" }
const _hoisted_9 = { class: "text-[10px] font-bold text-slate-500" }
const _hoisted_10 = { class: "text-xs font-black text-slate-900" }
const _hoisted_11 = { class: "flex items-start justify-between" }
const _hoisted_12 = { class: "text-xs font-bold text-slate-400" }
const _hoisted_13 = { class: "mt-2 text-3xl font-black text-slate-900" }
const _hoisted_14 = { class: "relative mt-4" }
const _hoisted_15 = {
  key: 0,
  class: "absolute bottom-full left-0 z-20 mb-3 w-52 rounded-xl bg-white border border-[#8c8c94] p-3.5 shadow-xl animate-in fade-in zoom-in-95 duration-200"
}
const _hoisted_16 = { class: "space-y-2.5" }
const _hoisted_17 = { class: "text-[10px] font-bold text-slate-500" }
const _hoisted_18 = { class: "text-xs font-black text-slate-900" }
const _hoisted_19 = { class: "flex items-start justify-between" }
const _hoisted_20 = { class: "mt-2 text-3xl font-black text-slate-900" }
const _hoisted_21 = { class: "flex items-start justify-between" }
const _hoisted_22 = { class: "mt-2 text-xl font-black text-slate-900" }
const _hoisted_23 = { class: "relative mt-4" }
const _hoisted_24 = {
  key: 0,
  class: "absolute bottom-full left-0 z-20 mb-3 w-52 rounded-xl bg-white border border-[#8c8c94] p-3.5 shadow-xl animate-in fade-in zoom-in-95 duration-200"
}
const _hoisted_25 = { class: "space-y-2.5" }
const _hoisted_26 = { class: "text-[10px] font-bold text-slate-500" }
const _hoisted_27 = { class: "text-xs font-black text-slate-900" }
const _hoisted_28 = {
  key: 4,
  class: "group flex flex-col justify-between rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-slate-300 hover:shadow-md"
}
const _hoisted_29 = { class: "flex items-start justify-between" }
const _hoisted_30 = { class: "mt-2 text-3xl font-black text-slate-900" }
const _hoisted_31 = { class: "mt-4 text-[10px] font-bold tracking-tight text-emerald-600 bg-emerald-50 px-2 py-1 rounded inline-block w-fit" }
const _hoisted_32 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "mb-6 grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6" }
const _hoisted_35 = { class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_36 = { class: "mb-4 flex items-start justify-between gap-3" }
const _hoisted_37 = { class: "min-w-[160px]" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "flex flex-col rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_40 = { class: "flex-1 flex items-center justify-center" }
const _hoisted_41 = { class: "flex flex-col rounded-2xl border border-slate-200 bg-white p-4 shadow-sm lg:col-span-2" }
const _hoisted_42 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_43 = {
  key: 1,
  class: "flex-1 flex flex-col items-center justify-center border-2 border-dashed border-slate-200 rounded-lg min-h-[300px] bg-slate-50"
}
const _hoisted_44 = { class: "mb-6 grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6" }
const _hoisted_45 = { class: "flex flex-col rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_46 = {
  key: 0,
  class: "flex-1 flex items-center justify-center"
}
const _hoisted_47 = {
  key: 1,
  class: "flex-1 flex flex-col items-center justify-center border-2 border-dashed border-slate-200 rounded-lg min-h-[320px] bg-slate-50"
}
const _hoisted_48 = { class: "flex flex-col rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_49 = {
  key: 0,
  class: "flex-1 mt-6"
}
const _hoisted_50 = {
  key: 1,
  class: "flex-1 mt-6 flex flex-col items-center justify-center border-2 border-dashed border-slate-200 rounded-lg min-h-[260px] bg-slate-50"
}
const _hoisted_51 = {
  key: 2,
  class: "mb-8 grid grid-cols-1 gap-4 lg:grid-cols-2"
}
const _hoisted_52 = {
  key: 3,
  class: "mb-8 grid grid-cols-1 gap-6 xl:grid-cols-2"
}
const _hoisted_53 = { class: "flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" }
const _hoisted_54 = { class: "overflow-x-auto" }
const _hoisted_55 = { class: "min-w-full text-sm" }
const _hoisted_56 = { class: "divide-y divide-slate-100" }
const _hoisted_57 = { class: "px-6 py-4" }
const _hoisted_58 = { class: "font-bold text-slate-900" }
const _hoisted_59 = { class: "mt-0.5 text-[10px] font-bold uppercase tracking-tight text-slate-400" }
const _hoisted_60 = { class: "px-6 py-4 font-mono font-medium text-slate-600" }
const _hoisted_61 = { class: "px-6 py-4 text-center" }
const _hoisted_62 = { class: "flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" }
const _hoisted_63 = { class: "overflow-x-auto" }
const _hoisted_64 = { class: "min-w-full text-sm" }
const _hoisted_65 = { class: "divide-y divide-slate-100" }
const _hoisted_66 = { class: "px-6 py-4 font-bold text-slate-900" }
const _hoisted_67 = { class: "px-6 py-4 font-medium text-slate-500 text-xs" }
const _hoisted_68 = { class: "px-6 py-4" }
const _hoisted_69 = { class: "flex items-center gap-2" }
const _hoisted_70 = { class: "rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-bold text-slate-500" }
const _hoisted_71 = {
  key: 4,
  class: "mt-12 rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-6 opacity-60 grayscale transition-all hover:opacity-100 hover:grayscale-0"
}
const _hoisted_72 = { class: "max-w-md" }
const _hoisted_73 = { class: "flex items-center gap-3" }
const _hoisted_74 = {
  key: 0,
  class: "mt-6 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm"
}
const _hoisted_75 = { class: "bg-slate-50 px-4 py-2 border-b border-slate-200 flex justify-between items-center" }
const _hoisted_76 = { class: "text-[10px] font-black uppercase text-slate-400" }
const _hoisted_77 = { class: "overflow-x-auto" }
const _hoisted_78 = { class: "min-w-full text-[10px]" }
const _hoisted_79 = { class: "bg-slate-50" }
const _hoisted_80 = { class: "divide-y divide-slate-100" }

import { computed, ref, onMounted } from "vue"
import { useRouter } from "vue-router"
import ApiService from "@/store/api.service"
import { usePermissions } from "@/hooks/usePermissions"
import {
  ADMIN_FULL_ROLES,
  BANTUAN_ROLES,
  FINANCE_ROLES,
  SECRETARIAT_ROLES,
  canAccess,
} from "@/utils/permissions"


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDashboard',
  setup(__props) {


const isPendingDropdownOpen = ref(false)
const isApprovedDropdownOpen = ref(false)
const isDonationDropdownOpen = ref(false)
const isChartsVisible = ref(false)
const router = useRouter()
const { selectedRoleId } = usePermissions()
const canViewBantuanDashboard = computed(() => canAccess(BANTUAN_ROLES, selectedRoleId.value))
const canViewFinanceDashboard = computed(() => canAccess(FINANCE_ROLES, selectedRoleId.value))
const canViewSecretariatDashboard = computed(() => canAccess(SECRETARIAT_ROLES, selectedRoleId.value))
const canViewAdminTools = computed(() => canAccess(ADMIN_FULL_ROLES, selectedRoleId.value))
const selectedTrendRange = ref('week')

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '')
const bankesDashboardApiUrl = trimTrailingSlash(process.env.VUE_APP_BANKES_DASHBOARD_API_URL || '')
const otaDashboardApiUrl = trimTrailingSlash(process.env.VUE_APP_OTA_DASHBOARD_API_URL || '')

const trendRangeOptions = [
  { value: 'week', label: '7 Hari' },
  { value: 'month', label: '1 Bulan' },
  { value: '3months', label: '3 Bulan' },
  { value: 'year', label: '1 Tahun' },
  { value: 'all', label: 'Semua' }
]

// ================= Ringkasan =================
const kpiData = ref({
  totalPengajuanPending: { 
    title: "Pengajuan Perlu Proses", 
    value: 0,
    breakdown: {
      iom: 0,
      bankes: 0,
      ota: 0
    }
  },
  totalBantuanDisetujui: { 
    title: "Bantuan Disetujui (Bulan Ini)", 
    value: 0,
    breakdown: { iom: 0, bankes: 0, ota: 0 }
  },
  pesananMerchandise: { title: "Pesanan Merchandise Baru", value: 0 },
  totalDonasi: { 
    title: "Donasi Terkumpul", 
    value: "Rp 0",
    breakdown: { iom: "Rp 0", ota: "Rp 0" }
  },
  totalAnggota: { title: "Total Anggota", value: 0, description: "" }
})

const trenChartKey = ref(0)
const statusChartKey = ref(0)

const trenChartSeries = ref<any[]>([])
const trenChartOptions = ref({
  chart: { type: 'line', toolbar: { show: false } },
  stroke: { curve: 'smooth', width: 3 },
  xaxis: { categories: [] as string[] },
  colors: ['#3B82F6']
})

const statusChartSeries = ref<number[]>([])
const statusChartOptions = ref({
  chart: { type: 'donut' },
  labels: [] as string[],
  colors: ['#10B981', '#F59E0B', '#EF4444', '#3B82F6'],
  legend: { show: true, position: 'bottom' }
})

const penerimaChartSeries = ref([{ name: 'Total Penerima Bantuan', data: [] as number[] }])
const penerimaChartOptions = ref({
  chart: { type: 'bar', toolbar: { show: false } },
  plotOptions: { bar: { borderRadius: 4, columnWidth: '50%' } },
  xaxis: { categories: [] as string[] },
  colors: ['#8B5CF6'],
  dataLabels: { enabled: false }
})

// === GRAFIK BANKES & OTA ===
const otaCapacityChartSeries = ref<number[]>([])
const otaCapacityChartOptions = ref({
  chart: { type: 'donut' },
  labels: ['Sudah Terpakai', 'Sisa Kosong'],
  colors: ['#F59E0B', '#10B981'], // Orange for used, Green for free
  legend: { show: true, position: 'bottom' }
})

const otaBillingChartSeries = ref([{ name: 'Jumlah Donatur', data: [] as number[] }])
const otaBillingChartOptions = ref({
  chart: { type: 'bar', toolbar: { show: false } },
  plotOptions: { bar: { borderRadius: 4, columnWidth: '40%' } },
  xaxis: { categories: ['Sudah Lunas', 'Menunggak'] },
  colors: ['#3B82F6'],
  dataLabels: { enabled: false }
})

const recentSubmissions = ref<any[]>([])
const activityLogs = ref<any[]>([])

const formatDateKey = (date: Date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const normalizeDateKey = (value: string) => {
  if (!value) return ''
  if (value.length >= 10) return value.slice(0, 10)
  return formatDateKey(new Date(value))
}

const formatMonthLabel = (dateValue: string) => {
  const date = new Date(dateValue)
  return date.toLocaleDateString('id-ID', { month: 'short' })
}

const formatTrendLabel = (dateValue: string, range: string) => {
  const date = new Date(dateValue)

  if (range === 'week') {
    return getDayName(date)
  }

  return date.toLocaleDateString('id-ID', {
    day: '2-digit',
    month: 'short'
  })
}

const buildTrendCategories = (items: Array<{ date: string }>, range: string) => {
  const normalizedRange = String(range).toLowerCase()

  if (normalizedRange === 'week') {
    return items.map((x) => formatTrendLabel(x.date, range))
  }

  if (normalizedRange === 'year') {
    return items.map((x) => {
      const date = new Date(x.date)
      return date.getDate() === 1 ? formatMonthLabel(x.date) : ''
    })
  }

  const step = normalizedRange === '3months' ? 14 : 7
  return items.map((x, index) => (index % step === 0 ? formatTrendLabel(x.date, range) : ''))
}

const loadCharts = async (range = selectedTrendRange.value) => {
  try {
    const chartRes: any = await ApiService.get('/dashboard/charts', { range })
    const charts = chartRes.data || chartRes

    const trendItems = charts.trenPengajuan || []
    const rangeMap: Record<string, number | null> = {
      week: 7,
      month: 30,
      '3months': 90,
      year: 365,
      all: null
    }
    const selectedDays = rangeMap[String(range).toLowerCase()] ?? 7
    let filledTrendItems = trendItems

    if (selectedDays !== null) {
      const totalsByDate = new Map(
        trendItems.map((item: any) => [normalizeDateKey(String(item.date)), Number(item.total) || 0])
      )

      const endDate = new Date()
      endDate.setHours(23, 59, 59, 999)
      const startDate = new Date(endDate)
      startDate.setDate(endDate.getDate() - (selectedDays - 1))
      startDate.setHours(0, 0, 0, 0)

      const filled: Array<{ date: string; total: number }> = []
      const cursor = new Date(startDate)

      while (cursor <= endDate) {
        const key = formatDateKey(cursor)
        filled.push({ date: key, total: totalsByDate.get(key) || 0 })
        cursor.setDate(cursor.getDate() + 1)
      }

      filledTrendItems = filled
    }

    trenChartSeries.value = [{
      name: 'Pengajuan',
      data: filledTrendItems.map((x: any) => Number(x.total) || 0)
    }]

    trenChartOptions.value = {
      ...trenChartOptions.value,
      xaxis: {
        categories: buildTrendCategories(filledTrendItems, range)
      }
    }

    trenChartKey.value++

    const statusItems = (charts.distribusiStatus || []).filter((x: any) => x.currentStatus !== 'TIDAK_DIKETAHUI')

    statusChartSeries.value = statusItems.map((x: any) => Number(x.total) || 0)
    statusChartOptions.value = {
      ...statusChartOptions.value,
      labels: statusItems.map((x: any) => mapStatus(x.currentStatus))
    }

    statusChartKey.value++

    penerimaChartSeries.value = [{
      name: 'Total Penerima Bantuan',
      data: charts.penerimaPerTahun?.map((x: any) => Number(x.total) || 0) || []
    }]

    penerimaChartOptions.value = {
      ...penerimaChartOptions.value,
      xaxis: {
        categories: charts.penerimaPerTahun?.map((x: any) => x.year) || []
      }
    }
  } catch (err) {
    console.error('Failed to load dashboard charts:', err)
  }
}

const handleTrendRangeChange = () => {
  if (!canViewBantuanDashboard.value) return
  void loadCharts(selectedTrendRange.value)
}

const goToPaymentDashboard = () => {
  if (!canViewFinanceDashboard.value) return
  router.push('/dashboard-pembayaran')
}

const goToMerchandiseDashboard = () => {
  if (!canViewFinanceDashboard.value) return
  router.push('/merchandise-dashboard')
}

async function fetchExternalDashboardData<T>(endpoint: string, label: string, envKey: string): Promise<T[]> {
  if (!endpoint) {
    throw new Error(`${label} dashboard API URL is not configured. Set ${envKey}.`)
  }

  const response = await fetch(endpoint)

  if (!response.ok) {
    throw new Error(`${label} dashboard API request failed with status ${response.status}`)
  }

  const result = await response.json()
  return Array.isArray(result.data) ? result.data : []
}

const fetchDashboard = async () => {
  try {
    const statsRes: any = await ApiService.get('/dashboard/stats')
    const stats = statsRes.data || statsRes

    // Init the basic IOM values
    let totalIOMPending = stats.totalPending || 0
    let totalBankesPending = 0
    let totalOTAPending = 0

    let totalIOMApproved = stats.approvedThisMonth || 0
    let totalBankesApproved = 0
    let totalOTAApproved = 0

    let totalIOMDonasi = stats.totalDonasi || 0
    let totalOTADonasiAmount = 0

    if (canViewBantuanDashboard.value) {
    try {
      // Hit Bankes Asli API to aggregate data
      const bankesData = await fetchExternalDashboardData<any>(
        bankesDashboardApiUrl,
        'Bankes',
        'VUE_APP_BANKES_DASHBOARD_API_URL'
      )
      
      // Count pending (Logika baru berdasarkan bankesStatus: 'unverified')
      totalBankesPending = bankesData.filter((mhs: any) => mhs.bankesStatus === 'unverified').length
      
      // Count approved / verified (Logika baru berdasarkan bankesStatus: 'verified')
      totalBankesApproved = bankesData.filter((mhs: any) => mhs.bankesStatus === 'verified').length

      // Hitungan dummy pendings OTA (bisa disesuaikan lagi nanti)
      totalOTAPending = bankesData.length > 2 ? 1 : 0 
      totalOTAApproved = 0 
    } catch (e) {
      console.warn("Failed to fetch Bankes data:", e)
    }
    }

    if (canViewFinanceDashboard.value) {
    try {
      // Hit OTA-KU API.
      const otaData = await fetchExternalDashboardData<any>(
        otaDashboardApiUrl,
        'OTA-KU',
        'VUE_APP_OTA_DASHBOARD_API_URL'
      )
      
      // Sum the funds from all OTAs (Asumsi tim merek mengeluarkan property 'funds')
      totalOTADonasiAmount = otaData.reduce((sum: number, ota: any) => sum + (ota.funds || 0), 0)

      // Hitung Kapasitas OTA
      const totalCapacity = otaData.reduce((sum: number, ota: any) => sum + (ota.maxCapacity || 0), 0)
      const usedCapacity = otaData.reduce((sum: number, ota: any) => sum + (ota.usedCapacity || 0), 0)
      otaCapacityChartSeries.value = [usedCapacity, Math.max(0, totalCapacity - usedCapacity)]

      // Hitung Status Tagihan Donatur
      let lunasCount = 0
      let nunggakCount = 0
      
      otaData.forEach((ota: any) => {
        if (ota.paymentStatus === 'lunas') lunasCount++
        else if (ota.paymentStatus === 'menunggak') nunggakCount++
      })
      
      otaBillingChartSeries.value = [{ name: 'Jumlah Donatur', data: [lunasCount, nunggakCount] }]

    } catch (e) {
      console.warn("Failed to fetch OTA-KU data:", e)
    }
    }

    // Apply Pendings
    kpiData.value.totalPengajuanPending.value = totalIOMPending + totalBankesPending + totalOTAPending
    kpiData.value.totalPengajuanPending.breakdown.iom = totalIOMPending
    kpiData.value.totalPengajuanPending.breakdown.bankes = totalBankesPending
    kpiData.value.totalPengajuanPending.breakdown.ota = totalOTAPending

    // Apply Approved
    kpiData.value.totalBantuanDisetujui.value = totalIOMApproved + totalBankesApproved + totalOTAApproved
    kpiData.value.totalBantuanDisetujui.breakdown.iom = totalIOMApproved
    kpiData.value.totalBantuanDisetujui.breakdown.bankes = totalBankesApproved
    kpiData.value.totalBantuanDisetujui.breakdown.ota = totalOTAApproved

    // Apply Donasi
    const totalDonasiAll = totalIOMDonasi + totalOTADonasiAmount
    kpiData.value.totalDonasi.value = "Rp " + formatNumber(totalDonasiAll)
    kpiData.value.totalDonasi.breakdown.iom = "Rp " + formatNumber(totalIOMDonasi)
    kpiData.value.totalDonasi.breakdown.ota = "Rp " + formatNumber(totalOTADonasiAmount)

    kpiData.value.pesananMerchandise.value = stats.pesananBaru || 0
    kpiData.value.totalAnggota.value = stats.totalAnggota
    kpiData.value.totalAnggota.description =
      `+${stats.anggotaBaru} anggota baru bulan ini`

    if (canViewBantuanDashboard.value) {
      await loadCharts(selectedTrendRange.value)

      const recentRes: any = await ApiService.get('/dashboard/recent')
      const recent = recentRes.data || recentRes

      recentSubmissions.value = recent.pengajuanTerbaru?.map((x:any)=>({
        id: x.id,
        name: x.name,
        nim: x.nim,
        type: x.type,
        date: formatDate(x.submittedAt),
        status: mapStatus(x.pengajuanStatus?.currentStatus)
      })) || []

      activityLogs.value = recent.logAktivitas?.map((x:any)=>({
        id: Math.random(),
        admin: x.changedBy === 'SEEDER' ? 'Sistem' : x.changedBy,
        time: formatDate(x.changedAt),
        oldStatus: mapStatus(x.oldStatus),
        newStatus: mapStatus(x.newStatus)
      })) || []
    } else {
      recentSubmissions.value = []
      activityLogs.value = []
      trenChartSeries.value = []
      statusChartSeries.value = []
      penerimaChartSeries.value = [{ name: 'Total Penerima Bantuan', data: [] }]
    }

  } catch (err) {
    console.error("Dashboard error:", err)
  }
}

// helper
function formatNumber(num:number){
  return new Intl.NumberFormat('id-ID').format(num || 0)
}

function formatDate(date:string){
  if (!date) return "-"
  return new Date(date).toLocaleDateString('id-ID')
}
// helper nama hari
function getDayName(date: Date) {
  const days = ['Min','Sen','Sel','Rab','Kam','Jum','Sab']
  return days[date.getDay()]
}

function mapStatus(status:string){
  const map:any = {
    VERIFIKASI_BERKAS: 'Verifikasi Berkas',
    DIPANGGIL_WAWANCARA: 'Wawancara',
    KEPUTUSAN_DITERIMA: 'Disetujui',
    KEPUTUSAN_DITOLAK: 'Ditolak',
    TIDAK_DIKETAHUI: 'Tidak Diketahui'
  }
  return map[status] || status
}

const csvRows=ref<string[][]>([])

function handleCsvUpload(event:Event){
const file=(event.target as HTMLInputElement).files?.[0]
if(!file)return

const reader=new FileReader()
reader.onload=(e)=>{
const text=e.target?.result as string
csvRows.value=text
.trim()
.split("\n")
.map(line=>line.split(",").map(cell=>cell.trim()))
}
reader.readAsText(file)
}
onMounted(fetchDashboard)


return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", { class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6 mb-6" }, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
      _createElementVNode("div", { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }, [
        _cache[9] || (_cache[9] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-2xl font-bold md:text-4xl" }, "Dashboard"),
          _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, " Pantau dan kelola ringkasan statistik layanan, status pengajuan bantuan, serta progres donasi secara menyeluruh. ")
        ], -1)),
        _createElementVNode("button", {
          class: "inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#003793] shadow-lg transition-all hover:-translate-y-px hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-white/70 sm:w-auto",
          onClick: fetchDashboard
        }, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2.5",
              d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            })
          ], -1),
          _createTextVNode(" Refresh Data ", -1)
        ]))])
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (canViewBantuanDashboard.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "group relative flex flex-col justify-between overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-indigo-200 hover:shadow-md cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isPendingDropdownOpen.value = !isPendingDropdownOpen.value))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(kpiData.value.totalPengajuanPending.title), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(kpiData.value.totalPengajuanPending.value), 1)
              ]),
              _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"text-indigo-500/80 transition-transform group-hover:scale-110\"><svg class=\"h-9 w-9\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\"><path d=\"M14.25 2.75H7A2.25 2.25 0 0 0 4.75 5v14A2.25 2.25 0 0 0 7 21.25h10A2.25 2.25 0 0 0 19.25 19v-9.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M14.25 2.75v5A2.25 2.25 0 0 0 16.5 10h2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.25 14.25c0-1.05.86-1.9 1.92-1.9.8 0 1.48.46 1.78 1.13.3-.67.98-1.13 1.78-1.13 1.06 0 1.92.85 1.92 1.9 0 2.75-3.7 4.7-3.7 4.7s-3.7-1.95-3.7-4.7Z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 1))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isPendingDropdownOpen.value = !isPendingDropdownOpen.value), ["stop"])),
                class: "flex items-center gap-1.5 text-[11px] font-bold text-indigo-600 transition-opacity hover:opacity-80"
              }, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("svg", {
                  class: "h-3.5 w-3.5",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2.5"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ], -1),
                _createElementVNode("span", null, "Lihat Rincian", -1)
              ]))]),
              (isPendingDropdownOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiData.value.totalPengajuanPending.breakdown, (val, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "flex justify-between items-center"
                        }, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(key === 'iom' ? 'Bantuan IOM' : key === 'bankes' ? 'Kesehatan' : 'OTA'), 1),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(val), 1)
                        ]))
                      }), 128))
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "absolute -bottom-[5px] left-4 h-2.5 w-2.5 rotate-45 bg-white border-b border-r border-[#8c8c94]" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (canViewBantuanDashboard.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "group relative flex flex-col justify-between overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-blue-200 hover:shadow-md cursor-pointer",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (isApprovedDropdownOpen.value = !isApprovedDropdownOpen.value))
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(kpiData.value.totalBantuanDisetujui.title), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(kpiData.value.totalBantuanDisetujui.value), 1)
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-blue-500/80 transition-transform group-hover:scale-110" }, [
                _createElementVNode("svg", {
                  class: "h-9 w-9",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.5"
                }, [
                  _createElementVNode("path", {
                    d: "M12 3.75 4.5 6.75v5.625c0 4.238 2.832 8.05 7.5 9.375 4.668-1.325 7.5-5.137 7.5-9.375V6.75L12 3.75Z",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("path", {
                    d: "M8.75 12.15c0-1.05.82-1.9 1.85-1.9.62 0 1.16.3 1.4.78.24-.48.78-.78 1.4-.78 1.03 0 1.85.85 1.85 1.9 0 2.25-3.25 3.95-3.25 3.95s-3.25-1.7-3.25-3.95Z",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ])
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (isApprovedDropdownOpen.value = !isApprovedDropdownOpen.value), ["stop"])),
                class: "flex items-center gap-1.5 text-[11px] font-bold text-blue-600 transition-opacity hover:opacity-80"
              }, [...(_cache[16] || (_cache[16] = [
                _createElementVNode("svg", {
                  class: "h-3.5 w-3.5",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2.5"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ], -1),
                _createElementVNode("span", null, "Komposisi Bantuan", -1)
              ]))]),
              (isApprovedDropdownOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiData.value.totalBantuanDisetujui.breakdown, (val, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "flex justify-between items-center"
                        }, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(key === 'iom' ? 'Bantuan IOM' : key === 'bankes' ? 'Kesehatan' : 'OTA'), 1),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(val), 1)
                        ]))
                      }), 128))
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "absolute -bottom-[5px] left-4 h-2.5 w-2.5 rotate-45 bg-white border-b border-r border-[#8c8c94]" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (canViewFinanceDashboard.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "group flex flex-col justify-between rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-sky-200 hover:shadow-md cursor-pointer",
            onClick: goToMerchandiseDashboard
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", null, [
                _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-xs font-bold text-slate-400" }, "Merchandise", -1)),
                _createElementVNode("p", _hoisted_20, _toDisplayString(kpiData.value.pesananMerchandise.value), 1)
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-sky-500/80 transition-transform group-hover:scale-110" }, [
                _createElementVNode("svg", {
                  class: "h-9 w-9",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.5"
                }, [
                  _createElementVNode("path", {
                    d: "M9 4.75 7 6.25l-3.25 1.5 2 4.75 2.5-1V20h7.5v-8.5l2.5 1 2-4.75-3.25-1.5-2-1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("path", {
                    d: "M9 4.75c.55 1.1 1.55 1.75 3 1.75s2.45-.65 3-1.75",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ])
              ], -1))
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mt-4 flex items-center gap-1 text-[11px] font-bold text-sky-600" }, [
              _createElementVNode("span", null, "Kelola pesanan"),
              _createElementVNode("svg", {
                class: "h-3 w-3",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  d: "M13 7l5 5m0 0l-5 5m5-5H6",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ])
            ], -1))
          ]))
        : _createCommentVNode("", true),
      (canViewFinanceDashboard.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "group relative flex flex-col justify-between overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-[#003793]/20 hover:shadow-md cursor-pointer",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (isDonationDropdownOpen.value = !isDonationDropdownOpen.value))
          }, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", null, [
                _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-xs font-bold text-slate-400" }, "Donasi Masuk", -1)),
                _createElementVNode("p", _hoisted_22, _toDisplayString(kpiData.value.totalDonasi.value), 1)
              ]),
              _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"text-[#003793]/70 transition-transform group-hover:scale-110\"><svg class=\"h-9 w-9\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\"><path d=\"M3.5 14.75h3.25l2.7 2.15a3.25 3.25 0 0 0 2.04.72h3.26c.85 0 1.55-.7 1.55-1.55s-.7-1.55-1.55-1.55h-3.1\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7 14.75l1.75-1.35a3.1 3.1 0 0 1 1.9-.65h2.1a1.55 1.55 0 0 1 1.55 1.55\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.25 7.5a3.25 3.25 0 1 0-6.5 0 3.25 3.25 0 0 0 6.5 0Z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M14 5.95v3.1M12.75 7.5h2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 1))
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (isDonationDropdownOpen.value = !isDonationDropdownOpen.value), ["stop"])),
                class: "flex items-center gap-1.5 text-[11px] font-bold text-[#003793] transition-opacity hover:opacity-80"
              }, [...(_cache[23] || (_cache[23] = [
                _createElementVNode("svg", {
                  class: "h-3.5 w-3.5",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2.5"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ], -1),
                _createElementVNode("span", null, "Sumber Dana", -1)
              ]))]),
              (isDonationDropdownOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiData.value.totalDonasi.breakdown, (val, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "flex justify-between items-center"
                        }, [
                          _createElementVNode("span", _hoisted_26, _toDisplayString(key === 'iom' ? 'Donasi IOM' : 'Komitmen OTA'), 1),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(val), 1)
                        ]))
                      }), 128))
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "absolute -bottom-[5px] left-4 h-2.5 w-2.5 rotate-45 bg-white border-b border-r border-[#8c8c94]" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (canViewSecretariatDashboard.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", null, [
                _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-xs font-bold text-slate-400" }, "Total Anggota", -1)),
                _createElementVNode("p", _hoisted_30, _toDisplayString(kpiData.value.totalAnggota.value), 1)
              ]),
              _cache[26] || (_cache[26] = _createStaticVNode("<div class=\"rounded-xl bg-slate-50 p-2.5 text-slate-600 transition-colors group-hover:bg-slate-100\"><svg class=\"h-6 w-6\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" stroke-width=\"1.7\"><path d=\"M15 19.25a6.5 6.5 0 0 0-13 0\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.5 12.25a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16.25 11.75 18 13.5l3.25-4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 1))
            ]),
            _createElementVNode("p", _hoisted_31, _toDisplayString(kpiData.value.totalAnggota.description), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (canViewBantuanDashboard.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (isChartsVisible.value = !isChartsVisible.value)),
            class: "group flex w-full items-center justify-between rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition-all hover:bg-blue-50/30 focus:outline-none"
          }, [
            _cache[28] || (_cache[28] = _createStaticVNode("<div class=\"flex items-center gap-4\"><div class=\"rounded-xl bg-blue-50 p-2.5 text-blue-600 transition-colors group-hover:bg-blue-100\"><svg class=\"h-6 w-6\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" stroke-width=\"1.7\"><path d=\"M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75H3v-6.75Z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25h-4.5V8.625Z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75h-4.5V4.125Z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div><div class=\"text-left\"><h4 class=\"text-xs font-bold text-blue-600\">Analisis Data</h4><span class=\"text-lg font-black text-slate-800\">Visualisasi Statistik &amp; Grafik</span></div></div>", 1)),
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["w-5 h-5 text-slate-400 transition-transform duration-300", { 'rotate-180': isChartsVisible.value }]),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [...(_cache[27] || (_cache[27] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2.5",
                d: "M19 9l-7 7-7-7"
              }, null, -1)
            ]))], 2))
          ])
        ]))
      : _createCommentVNode("", true),
    (isChartsVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[29] || (_cache[29] = _createElementVNode("div", null, [
                  _createElementVNode("h3", { class: "text-slate-700 font-bold text-lg" }, "Tren Pengajuan Masuk"),
                  _createElementVNode("p", { class: "text-xs text-slate-500" }, "Pilih rentang waktu untuk melihat perubahan tren")
                ], -1)),
                _createElementVNode("div", _hoisted_37, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedTrendRange).value = $event)),
                    onChange: handleTrendRangeChange,
                    class: "block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(trendRangeOptions, (range) => {
                      return _createElementVNode("option", {
                        key: range.value,
                        value: range.value
                      }, _toDisplayString(range.label), 9, _hoisted_38)
                    }), 64))
                  ], 544), [
                    [_vModelSelect, selectedTrendRange.value]
                  ])
                ])
              ]),
              (_openBlock(), _createBlock(_component_apexchart, {
                key: trenChartKey.value,
                type: "line",
                height: "300",
                options: trenChartOptions.value,
                series: trenChartSeries.value
              }, null, 8, ["options", "series"]))
            ]),
            _createElementVNode("div", _hoisted_39, [
              _cache[30] || (_cache[30] = _createElementVNode("h3", { class: "text-slate-700 font-bold text-lg mb-4" }, "Distribusi Status Bantuan", -1)),
              _createElementVNode("div", _hoisted_40, [
                (_openBlock(), _createBlock(_component_apexchart, {
                  key: statusChartKey.value,
                  type: "donut",
                  height: "320",
                  options: statusChartOptions.value,
                  series: statusChartSeries.value
                }, null, 8, ["options", "series"]))
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _cache[32] || (_cache[32] = _createElementVNode("h3", { class: "text-slate-700 font-bold text-lg mb-4" }, "Penerima Bantuan per Tahun", -1)),
              (penerimaChartSeries.value[0]?.data?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createVNode(_component_apexchart, {
                      type: "bar",
                      height: "300",
                      options: penerimaChartOptions.value,
                      series: penerimaChartSeries.value
                    }, null, 8, ["options", "series"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_43, [...(_cache[31] || (_cache[31] = [
                    _createElementVNode("svg", {
                      class: "w-12 h-12 text-slate-300 mb-3",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                      })
                    ], -1),
                    _createElementVNode("span", { class: "text-slate-500 font-medium" }, "Belum ada data penerima bantuan", -1)
                  ]))]))
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _cache[34] || (_cache[34] = _createElementVNode("h3", { class: "text-slate-700 font-bold text-lg mb-4" }, "Kapasitas Orang Tua Asuh", -1)),
              (otaCapacityChartSeries.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createVNode(_component_apexchart, {
                      type: "donut",
                      height: "320",
                      options: otaCapacityChartOptions.value,
                      series: otaCapacityChartSeries.value
                    }, null, 8, ["options", "series"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_47, [...(_cache[33] || (_cache[33] = [
                    _createElementVNode("svg", {
                      class: "w-12 h-12 text-slate-300 mb-3",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      })
                    ], -1),
                    _createElementVNode("span", { class: "text-slate-500 font-medium text-sm" }, "Belum ada data kapasitas orang tua asuh", -1)
                  ]))]))
            ]),
            _createElementVNode("div", _hoisted_48, [
              _cache[36] || (_cache[36] = _createElementVNode("h3", { class: "text-slate-700 font-bold text-lg mb-4" }, "Status Tagihan Donatur (OTA)", -1)),
              ((otaBillingChartSeries.value[0]?.data?.[0] || 0) + (otaBillingChartSeries.value[0]?.data?.[1] || 0) > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createVNode(_component_apexchart, {
                      type: "bar",
                      height: "260",
                      options: otaBillingChartOptions.value,
                      series: otaBillingChartSeries.value
                    }, null, 8, ["options", "series"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_50, [...(_cache[35] || (_cache[35] = [
                    _createElementVNode("svg", {
                      class: "w-12 h-12 text-slate-300 mb-3",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                      })
                    ], -1),
                    _createElementVNode("span", { class: "text-slate-500 font-medium text-sm" }, "Belum ada data tagihan donatur", -1)
                  ]))]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (canViewFinanceDashboard.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createElementVNode("div", {
            class: "group relative flex items-center gap-5 overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:border-blue-200 hover:shadow-md cursor-pointer",
            onClick: goToPaymentDashboard
          }, [...(_cache[37] || (_cache[37] = [
            _createStaticVNode("<div class=\"rounded-2xl bg-blue-50 p-4 text-blue-600 transition-colors group-hover:bg-blue-100\"><svg class=\"h-8 w-8\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" stroke-width=\"1.7\"><path d=\"M4 19.25h16\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M6.25 16.25v-4.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.75 16.25v-8.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.25 16.25v-11.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.75 5.75h5.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.75 8.75h3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div><div><p class=\"text-xs font-bold uppercase tracking-widest text-blue-600\">Keuangan &amp; Donasi</p><h3 class=\"text-lg font-black text-slate-800\">Dashboard Pembayaran</h3><p class=\"mt-1 text-sm text-slate-500 leading-relaxed\"> Monitor aliran dana, konfirmasi manual, dan rekonsiliasi Midtrans. </p></div><div class=\"absolute right-6 top-1/2 -translate-y-1/2 opacity-0 transition-all group-hover:translate-x-1 group-hover:opacity-100\"><svg class=\"h-6 w-6 text-blue-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path d=\"M9 5l7 7-7 7\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 3)
          ]))]),
          _createElementVNode("div", {
            class: "group relative flex items-center gap-5 overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:border-sky-200 hover:shadow-md cursor-pointer",
            onClick: goToMerchandiseDashboard
          }, [...(_cache[38] || (_cache[38] = [
            _createStaticVNode("<div class=\"rounded-2xl bg-sky-50 p-4 text-sky-600 transition-colors group-hover:bg-sky-100\"><svg class=\"h-8 w-8\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" stroke-width=\"1.7\"><path d=\"M4.5 8.5 12 4.5l7.5 4-7.5 4-7.5-4Z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.5 8.5v7l7.5 4 7.5-4v-7\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12 12.5v7\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.25 15.75v-2M12 16.75v-3M15.75 17.5v-4.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div><div><p class=\"text-xs font-bold uppercase tracking-widest text-sky-600\">E-Commerce &amp; Logistik</p><h3 class=\"text-lg font-black text-slate-800\">Dashboard Merchandise</h3><p class=\"mt-1 text-sm text-slate-500 leading-relaxed\"> Kelola stok produk, pesanan baru, dan status pengiriman barang. </p></div><div class=\"absolute right-6 top-1/2 -translate-y-1/2 opacity-0 transition-all group-hover:translate-x-1 group-hover:opacity-100\"><svg class=\"h-6 w-6 text-sky-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path d=\"M9 5l7 7-7 7\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 3)
          ]))])
        ]))
      : _createCommentVNode("", true),
    (canViewBantuanDashboard.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _cache[40] || (_cache[40] = _createStaticVNode("<div class=\"flex items-center justify-between border-b border-slate-100 bg-white px-6 py-4\"><div><h3 class=\"text-lg font-black text-slate-800\">Pengajuan Bantuan Terbaru</h3><p class=\"text-xs font-medium text-slate-500\">Antrian verifikasi berkas mahasiswa.</p></div><div class=\"rounded-lg bg-slate-50 p-2 text-slate-400\"><svg class=\"h-5 w-5\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path d=\"M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div></div>", 1)),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("table", _hoisted_55, [
                _cache[39] || (_cache[39] = _createElementVNode("thead", { class: "bg-blue-900" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold uppercase tracking-wider text-blue-100" }, "Nama Pemohon"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold uppercase tracking-wider text-blue-100" }, "NIM"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-center text-[11px] font-bold uppercase tracking-wider text-blue-100" }, "Status")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_56, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentSubmissions.value, (submission) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: submission.id,
                      class: "transition-colors hover:bg-blue-50/30"
                    }, [
                      _createElementVNode("td", _hoisted_57, [
                        _createElementVNode("p", _hoisted_58, _toDisplayString(submission.name), 1),
                        _createElementVNode("p", _hoisted_59, _toDisplayString(submission.type) + " • " + _toDisplayString(submission.date), 1)
                      ]),
                      _createElementVNode("td", _hoisted_60, _toDisplayString(submission.nim), 1),
                      _createElementVNode("td", _hoisted_61, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-black uppercase tracking-tight", {
                      'bg-slate-50 text-slate-400 border-slate-200': submission.status === 'Tidak Diketahui',
                      'bg-indigo-50 text-indigo-700 border-indigo-100': submission.status === 'Verifikasi Berkas',
                      'bg-purple-50 text-purple-700 border-purple-100': submission.status === 'Wawancara',
                      'bg-amber-50 text-amber-700 border-amber-100': submission.status === 'Menunggu',
                      'bg-blue-50 text-blue-700 border-blue-100': submission.status === 'Diproses',
                      'bg-emerald-50 text-emerald-700 border-emerald-100': submission.status === 'Disetujui',
                      'bg-rose-50 text-rose-700 border-rose-100': submission.status === 'Ditolak'
                    }])
                        }, _toDisplayString(submission.status), 3)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _cache[43] || (_cache[43] = _createStaticVNode("<div class=\"flex items-center justify-between border-b border-slate-100 bg-white px-6 py-4\"><div><h3 class=\"text-lg font-black text-slate-800\">Log Aktivitas Terbaru</h3><p class=\"text-xs font-medium text-slate-500\">Riwayat perubahan status terakhir.</p></div><div class=\"rounded-lg bg-slate-50 p-2 text-slate-400\"><svg class=\"h-5 w-5\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div></div>", 1)),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("table", _hoisted_64, [
                _cache[42] || (_cache[42] = _createElementVNode("thead", { class: "bg-blue-900" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold uppercase tracking-wider text-blue-100" }, "Admin"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold uppercase tracking-wider text-blue-100" }, "Waktu"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold uppercase tracking-wider text-blue-100" }, "Perubahan Status")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_65, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityLogs.value, (log) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: log.id,
                      class: "transition-colors hover:bg-blue-50/30"
                    }, [
                      _createElementVNode("td", _hoisted_66, _toDisplayString(log.admin), 1),
                      _createElementVNode("td", _hoisted_67, _toDisplayString(log.time), 1),
                      _createElementVNode("td", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("span", _hoisted_70, _toDisplayString(log.oldStatus), 1),
                          _cache[41] || (_cache[41] = _createElementVNode("svg", {
                            class: "h-3 w-3 text-slate-300",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              d: "M14 5l7 7m0 0l-7 7m7-7H3",
                              "stroke-width": "3",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            })
                          ], -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["rounded px-1.5 py-0.5 text-[10px] font-bold", {
                        'bg-slate-100 text-slate-400': log.newStatus === 'Tidak Diketahui',
                        'bg-indigo-50 text-indigo-700': log.newStatus === 'Verifikasi Berkas',
                        'bg-purple-50 text-purple-700': log.newStatus === 'Wawancara',
                        'bg-yellow-50 text-yellow-600': log.newStatus === 'Menunggu',
                        'bg-blue-50 text-blue-700': log.newStatus === 'Diproses',
                        'bg-emerald-50 text-emerald-700': log.newStatus === 'Disetujui',
                        'bg-rose-50 text-rose-700': log.newStatus === 'Ditolak'
                      }])
                          }, _toDisplayString(log.newStatus), 3)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (canViewAdminTools.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
          _cache[45] || (_cache[45] = _createStaticVNode("<div class=\"mb-4 flex items-center gap-3\"><div class=\"rounded-lg bg-slate-200 p-2 text-slate-600\"><svg class=\"h-5 w-5\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" stroke-width=\"1.7\"><path d=\"M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div><div><h4 class=\"text-sm font-black text-slate-700 uppercase tracking-widest\">Developer Sandbox</h4><p class=\"text-xs text-slate-500 font-medium\">Tools untuk pengujian data csv dummy.</p></div></div>", 1)),
          _createElementVNode("div", _hoisted_72, [
            _cache[44] || (_cache[44] = _createElementVNode("label", { class: "block text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-2" }, "Import Dummy CSV", -1)),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("input", {
                type: "file",
                accept: ".csv",
                class: "block w-full text-xs text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-[11px] file:font-black file:uppercase file:bg-indigo-600 file:text-white hover:file:bg-indigo-700 cursor-pointer transition-all",
                onChange: handleCsvUpload
              }, null, 32)
            ])
          ]),
          (csvRows.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("p", _hoisted_76, "Preview Data (" + _toDisplayString(csvRows.value.length - 1) + " baris)", 1)
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("table", _hoisted_78, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_79, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(csvRows.value[0], (header) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: header,
                            class: "border-b border-slate-200 px-4 py-2 text-left font-bold text-slate-500 uppercase"
                          }, _toDisplayString(header), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_80, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(csvRows.value.slice(1,6), (row, i) => {
                        return (_openBlock(), _createElementBlock("tr", { key: i }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, j) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: j,
                              class: "px-4 py-2 text-slate-600 font-medium"
                            }, _toDisplayString(cell), 1))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})